<div class="client-info">
  @if (showImpersonateButton()) {
    <div class="action-row justify-end client-info__head">
      <button
        type="button"
        class="btn btn-outline"
        (click)="viewClientProfile()"
      >
        <i class="bi bi-box-arrow-in-right me-1"></i>
        Login as client
      </button>
    </div>
  }

  <app-add-edit-client></app-add-edit-client>
</div>
